import { Pagination } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { CallLogResult, CallLogState } from '../../store/CallLogSlice';
import classes from './CallLog.module.css';
import './CallLog.module.css';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { defaultPageSize } from '../../common/utils';
import { getCallLogs } from '../../actions/CallLogAction';
import { CallLogSearchParams } from './CallLog';
import { useOktaAuth } from "@okta/okta-react";

const CallLogResults = (props: { data: CallLogResult[] | null, callLogParams: CallLogSearchParams, apiUrl: string }) => {
    const { authState } = useOktaAuth();
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const { t, i18n } = useTranslation();
    const [params, setParams] = useState<CallLogSearchParams>({} as CallLogSearchParams);
    const [url, setUrl] = useState(props.apiUrl);
    const calls: CallLogState = useSelector((state: ApplicationState) => state.CallLog);

    useEffect(() => {
        setParams(props.callLogParams);
        setPage(1);
    }, []);

    const paginationChangeHandler = (event: any, value: number) => {
        if (authState !== null && authState.isAuthenticated && authState.accessToken !== undefined) {
            setPage(value);
            setParams(params);
            dispatch(getCallLogs(params, url, authState.accessToken, value, defaultPageSize, false));
        }
    };

    if (calls.data !== null && calls.data?.length > 0)
        return (
            <>
                <div className="row card m-1">
                    <div className="col p-0">
                        <table className="table table-light table-sm table-striped table-hover mb-0 calllogresults">
                            <caption className="resultHeader caption-top p-1 alert alert-danger m-0">Call Details</caption>
                            <thead className={"bg-danger text-white " + classes.tableHeader}>
                                <tr>
                                    <th className={classes.col1Width}>
                                        Category
                                    </th>
                                    <th className={classes.col2Width}>
                                        Status
                                    </th>
                                    <th className={classes.col3Width}>
                                        Created Date
                                    </th>
                                    <th>
                                        Notes
                                    </th>
                                </tr>
                            </thead>
                            <tbody className={classes.tableFont}>
                                {
                                    calls.data.map((call: CallLogResult) => (
                                        <tr key={call.callLogId}>
                                            <td data-label="Category">{call.categoryDescription}</td>
                                            <td data-label="Status">{call.status}</td>
                                            <td data-label="Created Date">{moment(call.createdDate).format(t('dateTimeFormat'))}</td>
                                            <td data-label="Notes">{call.notes}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    calls.data.length > 0 && (Math.ceil(calls.data[0].totalRecords/defaultPageSize) > 1) &&
                    (
                        <div className="row mt-1">
                            <div className="col text-center">
                                <div className="col">
                                    <Pagination count={Math.ceil(calls.data[0].totalRecords/defaultPageSize)} color="primary"
                                        page={page}
                                        onChange={paginationChangeHandler}
                                        variant="outlined" showFirstButton showLastButton />
                                </div>
                            </div>
                        </div>
                    )
                }
            </>
        )
    else {
        return <div className="row"><div className="col alert alert-warning text-center">There are no call logs for the time period</div></div>
    }
}

export default CallLogResults;